var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06176 7.66933C5.48796 4.24469 8.82961 2.01004 12.5393 2.00013C16.5375 1.97907 20.0926 4.54006 21.339 8.3391C22.5853 12.1381 21.2381 16.3074 18.0044 18.6588C14.7707 21.0103 10.3893 21.0068 7.15934 18.6501L4.27934 21.5301C3.98652 21.8226 3.51216 21.8226 3.21934 21.5301C2.92689 21.2373 2.92689 20.7629 3.21934 20.4701L6.00934 17.6801C3.40324 15.04 2.63556 11.094 4.06176 7.66933ZM5.39891 14.1691C6.59638 17.0547 9.41508 18.9342 12.5393 18.9301V18.8901C16.7796 18.8847 20.2219 15.4603 20.2493 11.2201C20.2534 8.09586 18.374 5.27717 15.4883 4.0797C12.6026 2.88223 9.27967 3.54208 7.07048 5.75127C4.86129 7.96046 4.20144 11.2834 5.39891 14.1691Z",
    fill: "#202224",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.93399981ab8d6acf0e104598d488c1bf.svg";
export { ForwardRef as ReactComponent };